import { Component, Inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IIncidents } from 'src/app/models/incident';

@Component({
  selector: 'app-snooze-incident-dialog',
  templateUrl: './snooze-incident-dialog.component.html',
  styleUrls: ['./snooze-incident-dialog.component.scss'],
})
export class SnoozeIncidentDialogComponent {
  snoozeForm = this.formbuilder.group({
    durationType: ['', Validators.required],
    durationSize: ['', Validators.required],
  });
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IIncidents,
    private formbuilder: FormBuilder
  ) {}
  selectedOption: string;
  statusOptions: string[] = ['Open', 'Close', 'Verified', 'Snoozed'];
  inputValidator(event: { charCode: number }) {
    return (
      (event.charCode != 8 && event.charCode == 0) ||
      (event.charCode >= 48 && event.charCode <= 57)
    );
  }
}
